import {
    IHealthDelegate,
    HealthDelegateEvent,
    HealthDelegateActor,
    HealthDelegateDataLoad,
    OutlookInstance,
} from '@outlook/hxcore_web';

type HxLoad = {
    type: 'load';
    healthData: HealthDelegateDataLoad;
};
type HxEvent = {
    type: 'event';
    healthData: HealthDelegateEvent;
};
type HxActor = {
    type: 'actor';
    healthData: HealthDelegateActor;
};
type HxHealthEvent = HxLoad | HxEvent | HxActor;

/**
 * Since diagnostics are not initialized until after boot and hx events are
 * especially interesting during boot, we stash events during boot and then
 * deliver them once diagnostics is ready for them.
 */
let bootHxHealthEvents: HxHealthEvent[] = [];
const bootHxHealthDelegate: IHealthDelegate = {
    loadResult: healthData =>
        bootHxHealthEvents.push({
            type: 'load',
            healthData,
        }),
    actorResult: healthData =>
        bootHxHealthEvents.push({
            type: 'actor',
            healthData,
        }),
    dataEvent: healthData =>
        bootHxHealthEvents.push({
            type: 'event',
            healthData,
        }),
};

let instance;
export function initializeHxHealth(hxInstance: OutlookInstance) {
    instance = hxInstance;
    instance.activeSet.registerHealthDelegate(bootHxHealthDelegate);
}

export function registerHxHealthDelegate(hxHealthDelegate: IHealthDelegate) {
    instance.activeSet.unregisterHealthDelegate(bootHxHealthDelegate);
    instance.activeSet.registerHealthDelegate(hxHealthDelegate);

    // Async to avoid sending the events until the diagnostic store is initialized
    Promise.resolve().then(() => sendBootHxHealthEvents(hxHealthDelegate));
}

function sendBootHxHealthEvents(hxHealthDelegate: IHealthDelegate) {
    bootHxHealthEvents.forEach(event => {
        switch (event.type) {
            case 'load':
                hxHealthDelegate.loadResult?.(event.healthData);
                break;
            case 'actor':
                hxHealthDelegate.actorResult?.(event.healthData);
                break;
            case 'event':
                hxHealthDelegate.dataEvent?.(event.healthData);
                break;
        }
    });
    bootHxHealthEvents = [];
}
